module.exports = __webpack_public_path__ + "static/media/participant_flow_model.ce23a034.svg";